import { Device } from '../types/device.js';
import { DeviceStatus } from '../types/device-status.js';
import { DeviceType } from '../types/device-type.js';
import { SuppressionMode } from '../types/suppression-mode.js';
import { AppUser } from '../types/user.js';

/** Admins operate every device; a member operates only devices whose `effectiveRole` is operator. */
export function canOperate(user: AppUser | null | undefined, device: Device): boolean {
  return !!user && (user.role === 'admin' || device.effectiveRole === 'operator');
}

/**
 * Returns true when the user may operate the device, the device is online,
 * the hardware supports suppression, TX is enabled, and suppression is not
 * disabled in device settings.
 */
export function canManageSuppressions(user: AppUser | null | undefined, device: Device): boolean {
  if (!canOperate(user, device)) {
    return false;
  }

  if (device.status !== DeviceStatus.ONLINE) {
    return false;
  }

  if (device.settings.deviceType !== DeviceType.DETECTOR_SUPPRESSOR) {
    return false;
  }

  if (device.settings.suppressionMode === SuppressionMode.DISABLED || !device.txEnabled) {
    return false;
  }

  return true;
}
